// extracted by mini-css-extract-plugin
module.exports = {"Container":"Container_3GRy8","Menu":"Menu_3QSMA","FullSize":"FullSize_tfzhw"};